 'use strict';

import * as THREE from 'three';
import {CSS2DObject} from "../../libs/CSS2DRenderer.js";
import { threeJsVariables, settingsData, isMobile, Buildings, projectMode } from '../../settings';
import { Box3 } from 'three';
import { poiLineUpdate, showPoi } from '../poi/poi';
import { getCurrentCameraDistance, getOrbitControlsDistanceAndAngle } from '../controls/orbitControls';
import {ViewMode} from "../../common";
 import { Vector2 } from 'three';

export function BuildingLabels(selectionBoxes) {

    if (projectMode.LiteMode.isActive()) return;

    const scene = threeJsVariables.scene;
    const buildingsLabelsGroup = new THREE.Group();
    const { y } = config.threejs.projectRotation;
    const {heightCorrection,resize} = config.threejs.label;
    buildingsLabelsGroup.name = 'buildingsLabelsGroup';
    buildingsLabelsGroup.rotation.set(0,y,0);
    //For Cnaan env
    // const selectionBoxesParent = selectionBoxes[0].parent;
    // buildingsLabelsGroup.position.set(selectionBoxesParent.position.x,selectionBoxesParent.position.y,selectionBoxesParent.position.z);
    // buildingsLabelsGroup.rotation.set(selectionBoxesParent.rotation.x,selectionBoxesParent.rotation.y,selectionBoxesParent.rotation.z);
    // buildingsLabelsGroup.scale.set(selectionBoxesParent.scale.x,1,selectionBoxesParent.scale.z);

    // buildings_info.forEach(building => {
    //     const buildingMesh = selectionBoxes.filter(sb => sb.name === `${building.name}_selectionBoxes`)[0];
    //     const sBoxSize = new Box3().setFromObject(buildingMesh).getSize(new THREE.Vector3());
    //     const labelContainer = document.createElement('div');
    //     const labelTowerNumber = building.labelName;
    //     // const labelTowerLetter = building.labelName.charAt(building.labelName.length - 1);
    //     labelContainer.className = 'building-labels';
    //
    //     labelContainer.setAttribute('data-attribute', building.labelName);
    //
    //     if (building.buildingIcon.length){
    //         labelContainer.innerHTML = `
    //     <div class='building-labels_wrapper' data-name="${building.name}" data-label="labelTower-${building.labelName}">
    //         <div class="building-labels__icon" style="background: url(${building.buildingIcon})"></div>
    //     </div>
    //     `;
    //
    //     } else {
    //
    //         labelContainer.innerHTML = `
    //     <div class='building-labels_wrapper' data-name="${building.name}" data-label="labelTower-${building.labelName}">
    //         <span>${labelTowerNumber}</span>
    //     </div>
    //     `;
    //     }
    //
    //     if (labelContainer) {
    //         if (labelContainer.getAttribute('data-attribute') === building.labelName) {
    //             labelContainer.classList.add('active');
    //         }
    //     }
    //     const label = new CSS2DObject(labelContainer);
    //     // const diffHightLabels = (window.innerWidth < 450) ? 20 : 15;
    //     // const diffHightLabels = (window.innerWidth < 450) ? 50 : 30; /// Remove when building position is 0,0,0
    //     const diffHightLabels = isMobile ? heightCorrection.mobile : heightCorrection.desktop;
    //
    //     label.name = `labelTower-${building.labelName}`;
    //     //label.material = new THREE.MeshBasicMaterial({color: 'red'});
    //
    //     // label.position.set(roofCenterPoint.x, roofCenterPoint.y + diffHightLabels, roofCenterPoint.z);
    //     label.position.set(buildingMesh.position.x, sBoxSize.y + diffHightLabels + buildingMesh.position.y, buildingMesh.position.z);
    //
    //     if (resize){
    //         const currentCameraDistance = getCurrentCameraDistance();
    //         label.userData.zoom = 1 / currentCameraDistance * 100 + 0.25;
    //     } else {
    //         label.userData.zoom = 1;
    //     }
    //
    //     // label.userData.zoom = isMobile ? 0.9 : 1;
    //
    //     buildingsLabelsGroup.add(label);
    //
    // });
    const buildings = Buildings.getBuildingsArray();

    buildings.forEach(building => {
        const buildingMesh = selectionBoxes.filter(sb => sb.name === `${building.name}_selectionBoxes`)[0];

        if (!buildingMesh) return;

        const sBoxSize = new Box3().setFromObject(buildingMesh).getSize(new THREE.Vector3());
        const labelContainer = document.createElement('div');
        const labelTowerNumber = building.info.labelName;
        // const labelTowerLetter = building.labelName.charAt(building.labelName.length - 1);
        labelContainer.className = 'building-labels';

        labelContainer.setAttribute('data-attribute', building.info.labelName);

        if (building.info.buildingIcon.length){
            labelContainer.innerHTML = `
        <div class='building-labels_wrapper' data-name="${building.name}" data-label="labelTower-${building.info.labelName}">
            <div class="building-labels__icon" style="background: url(${building.info.buildingIcon})"></div>
        </div>
        `;

        } else {

            labelContainer.innerHTML = `
        <div class='building-labels_wrapper' data-name="${building.name}" data-label="labelTower-${building.info.labelName}">
            <span>${labelTowerNumber}</span>
        </div>
        `;
        }

        if (labelContainer) {
            if (labelContainer.getAttribute('data-attribute') === building.info.labelName) {
                labelContainer.classList.add('active');
            }
        }
        const label = new CSS2DObject(labelContainer);
        // const diffHightLabels = (window.innerWidth < 450) ? 20 : 15;
        // const diffHightLabels = (window.innerWidth < 450) ? 50 : 30; /// Remove when building position is 0,0,0
        const diffHightLabels = isMobile ? heightCorrection.mobile : heightCorrection.desktop;

        label.name = `labelTower-${building.info.labelName}`;
        //label.material = new THREE.MeshBasicMaterial({color: 'red'});

        // label.position.set(roofCenterPoint.x, roofCenterPoint.y + diffHightLabels, roofCenterPoint.z);
        label.position.set(buildingMesh.position.x, sBoxSize.y + diffHightLabels + buildingMesh.position.y, buildingMesh.position.z);

        if (resize){
            const currentCameraDistance = getCurrentCameraDistance();
            label.userData.zoom = 1 / currentCameraDistance * 100 + 0.25;
        } else {
            label.userData.zoom = 1;
        }

        // label.userData.zoom = isMobile ? 0.9 : 1;

        buildingsLabelsGroup.add(label);

    });

    buildingsLabelHideWhenAnimationStart();

    scene.add(buildingsLabelsGroup);
}

// export function buildingsLabelsToggle (buildingIndex) {
//     const labelGroup = threeJsVariables.scene.getObjectByName('buildingsLabelsGroup');
//     const activeBuilding = buildings_info[buildingIndex];
//     const labelPrefix = "labelTower-";
//
//     labelGroup.traverse(label =>{
//         if (buildingIndex !== undefined){
//             if (label.name !== labelPrefix + activeBuilding.labelName){
//                 label.visible = false;
//             } else {
//                 label.visible = true;
//             }
//         } else {
//             label.visible = true;
//         }
//     });
//
// }

export function buildingsLabelResize () {

    if (!threeJsVariables.orbitControls.enabled || !config.threejs.label.resize){
        return;
    }
    const labelGroup = threeJsVariables.scene.getObjectByName('buildingsLabelsGroup');
    if (labelGroup){
        const currentCameraDistance = getCurrentCameraDistance();
        const {currentMinDistance,currentMaxDistance} = getOrbitControlsDistanceAndAngle();
        labelGroup.traverse(label =>{
            if (label.type === 'Object3D'){
                // if (currentCameraDistance < currentMinDistance + 5){
                    label.userData.zoom = 1 / currentCameraDistance * 100 + 0.25;
                //
                //     label.userData.zoom = isMobile ? 0.85 : 0.9;
                // } else {
                //     const calcZoom = 1 / currentCameraDistance * 100 + 0.25;
                //     if (isMobile){
                //         label.userData.zoom = calcZoom >= 0.85 ? 0.85 : calcZoom;
                //     } else {
                //         label.userData.zoom = calcZoom >= 0.9 ? 0.9 : calcZoom;
                //     }
                // }
            }
        });
        const canvas = threeJsVariables.renderer.getSize(new Vector2());
        threeJsVariables.labelRenderer.setSize( canvas.x, canvas.y );
        // threeJsVariables.labelRenderer.render(threeJsVariables.scene,threeJsVariables.perspectiveCamera);
    }
}

 // export function buildingsLabelUpdate () {
 //     const mainLabelContainer = threeJsVariables.labelRenderer.domElement;
 //     if (mainLabelContainer){
 //         mainLabelContainer.style.display = 'none';
 //         setTimeout(()=>{
 //             mainLabelContainer.style.display = 'block';
 //         },10);
 //     }
 // }

export function buildingsLabelUpdate () {

    if (settingsData.activeViewMode !== ViewMode.Orbit){
        return;
    }

    const buildingLabels = document.querySelectorAll('.building-labels_wrapper');

    if (buildingLabels.length) {
        buildingLabels.forEach(label =>{
            label.style.display = '';
        });
        // if (settingsData.activeViewMode !== ViewMode.Cylinder) {
        //     buildingLabels.style.display = 'none';
        //     setTimeout(() => {
        //         buildingLabels.removeAttribute('style')
        //         // showPoi();
        //     },10);
        // } else {
        //     buildingLabels.style.display = 'none';
        // }
    }
}

 export function showBuildingLabels () {
     const buildingLabels = document.querySelectorAll('.building-labels_wrapper');

     if (buildingLabels.length) {
         buildingLabels.forEach(label =>{
             label.style.display = '';
         });
     }
 }

// export function buildingsLabelHideWhenAnimationStart () {
//     if (settingsData.buildingDestroyed){
//         return;
//     }
//
//     const buildingLabels = document.querySelectorAll('.building-labels_wrapper');
//
//     if (buildingLabels.length){
//         buildingLabels.forEach(label =>{
//             label.style.display = 'none';
//         });
//     }
// }

 export function buildingsLabelHideWhenAnimationStart () {
     const buildingLabels = document.querySelectorAll('.building-labels_wrapper');

     if (buildingLabels.length){
         buildingLabels.forEach(label =>{
             label.style.display = 'none';
         });
     }
 }

export function hoverBuildingLabel () {
    const labelExist = threeJsVariables.scene.getObjectByName('Building hover label');
    if (!labelExist){
        const labelContainer = document.createElement('div');
        //labelContainer.textContent = 'Click to enter';
        labelContainer.classList.add('building__hover-label');

        const label = new CSS2DObject(labelContainer);
        label.name = 'Building hover label';
        label.visible = false;
        label.material = new THREE.MeshBasicMaterial({color: 0xffffff});
        label.userData.zoom = isMobile ? 0.9 : 1;
        threeJsVariables.scene.add(label);
    } else {

        const vec = new THREE.Vector3();
        vec.set(
          ( threeJsVariables.mouse.winX / window.innerWidth ) * 2 - 1,
          - ( threeJsVariables.mouse.winY / window.innerHeight ) * 2 + 1,
          0 );

        vec.unproject(threeJsVariables.perspectiveCamera);
        labelExist.position.set(vec.x,vec.y - 0.01,vec.z);
        labelExist.visible = true;

    }
}

export function hoverOutBuildingLabel () {
    const labelExist = threeJsVariables.scene.getObjectByName('Building hover label');
    if (labelExist){
        labelExist.visible = false;
    }
}
